<template>
  <el-dialog title="批量导入" :visible.sync="dialogVisibleLeadIn" width="900px">
    <div class="main">
      <div class="header">
        <div
          :class="{'header-item':true,'header-data-upLoad':item.id===1,'header-data-preview':item.id===2,'header-import-data':item.id===3}"
          v-for="(item,index) in stepsList"
          :key="index"
        >
          <div
            :class="activeIndex===item.id||item.id<=activeIndex?'pitch-on':'header-item-number'"
          >{{item.id}}</div>
          <div class="header-item-title">{{item.title}}</div>
          <div
            v-if="item.id!==3"
            :class="item.id<activeIndex?'header-item-lineAfter':'header-item-line'"
          ></div>
        </div>
      </div>
      <div :class="{'content':true,'top-content':activeIndex===1,'bottom-content':activeIndex===3}">
        <div class="upload-files" v-show="activeIndex===1">
          <el-row>
            <el-col :span="2" style="text-align:right;border: 1px solid transparent; ">
              <h4>1.</h4>
            </el-col>
            <el-col :span="22" class="title-content">
              <h4>填写导入数据信息</h4>
              <p class="p-content">请按照数据模版的格式准备导入数据，模版种的表头名称不可更改，表头行不能删除</p>
              <el-button @click="downLoadFile(guid)" plain type="primary">
                <i class="iconfont icon-xiazai" style="font-size:12px;"></i>下载模板
              </el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="text-align:right;border: 1px solid transparent; ">
              <h4>2.</h4>
            </el-col>
            <el-col :span="10" class="title-content">
              <h4>上传填好的信息表</h4>
              <el-upload
                ref="upload"
                class="upload-demo"
                :before-upload="beforeUpload"
                :action="actionUrl"
                :on-success="handleSuccess"
                :disabled="fileListUp.length !==0"
                :headers="uploadHeaders"
                :show-file-list="false"
                :file-list="fileList"
              >
                <div
                  slot="tip"
                  style="color:#83878A;"
                  class="el-upload__tip"
                >文件类型必须为Excel（xls或xlsx），大小不得大于10MB；</div>
                <el-button
                  :disabled="fileListUp.length !==0"
                  style="margin-top:10px;margin-bottom:0px;"
                  type="primary"
                >
                  <i class="iconfont icon-shangchuan1" style="font-size:12px;"></i>上传文件
                </el-button>
              </el-upload>
              <el-col :span="24" v-for="(item,index) in fileListUp" :key="index">
                <el-col
                  :span="18"
                  style="margin-top:10px;"
                >{{item.response.obj.guidAndFileName.fileName}}</el-col>
                <el-col :span="3">
                  <i @click="deleteExcel" class="el-icon-close" style="margin-top:15px;"></i>
                </el-col>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" style="text-align:right">
              <h4>
                <i
                  class="iconfont icon-tishi"
                  style="font-size:14px;color:#D35E5E;padding:2px !important;"
                ></i>
              </h4>
            </el-col>
            <el-col class="specail-suggestion title-content" :span="20">
              <h4 style="color:#D35E5E;">特别提示</h4>
              <p v-show="guid === $store.state.sellGuidIn">
                1、导入的产品数据如果品牌、型号、订货号在列表中已存在，根据货期与列表中匹配的数据合并；
                <br />2、要保证每个产品的型号、订货号至少填写一个；
                <br />3、货期、数量非必填项，如果填写应该为正整数；
                <br />4、仅支持上传Excel文件，大小不得大于1M，明细条目不大于1000条
              </p>
              <p v-show="guid === $store.state.financeLogisticCoeDerive">
                1、必填项不可为空；
                <br />2、寄件时间，格式为yyyy/mm/dd/hh/mm，精确到分；
                <br />3、承担人必须为系统内存在且启用的账号或者为公司；
                <br />4、结算重量、总体积、报价金额、物流费用为正数，保留两位有效数字；总件数为正整数；
                <br />5、仅支持上传Excel文件，大小不得大于1M，明细条目不大于1000条。
              </p>
            </el-col>
          </el-row>
        </div>
        <div class="data-preview" v-show="activeIndex===2">
          <div v-if="!isAbnormal">
            <div class="table-content" v-if="guid=== $store.state.sellGuidIn">
              <el-table
                ref="multipleTable"
                :data="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                tooltip-effect="dark"
                max-height="395"
                :header-cell-style="tableHeader"
                border
              >
                <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
                <el-table-column show-overflow-tooltip prop="proType" label="型号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ocNeednumber" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ocExtime" label="期望货期(天)"></el-table-column>
                <el-table-column show-overflow-tooltip label="销售单价">
                  <template slot-scope="scope">{{scope.row.ocPrice|priceFilter}}</template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table-content" v-if="guid === $store.state.financeLogisticCoeDerive">
              <el-table
                ref="multipleTable"
                :data="uploadTable.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                tooltip-effect="dark"
                max-height="395"
                :header-cell-style="tableHeader"
                border
              >
                <el-table-column show-overflow-tooltip prop="logicNumber" label="*物流单号" width="84"></el-table-column>
                <el-table-column show-overflow-tooltip prop="logicCompany" label="*快递名称" width="84"></el-table-column>
                <el-table-column show-overflow-tooltip label="*寄件时间" width="125">
                  <template slot-scope="scope">{{scope.row.deliveryDate|dateFilterL}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="bearUser" label="*承担人" width="70"></el-table-column>
                <el-table-column show-overflow-tooltip prop="deliveryAddress" label="寄件地址"></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="deliveryPhone"
                  label="寄件人电话"
                  width="98"
                ></el-table-column>
                <el-table-column show-overflow-tooltip prop="receivePeople" label="收件人"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiveAddress" label="收件地址"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receivePhone" label="收件人电话" width="98"></el-table-column>
                <el-table-column show-overflow-tooltip prop="weight" label="*结算重量（kg）" width="130"></el-table-column>
                <el-table-column show-overflow-tooltip prop="totalVolume" label="总体积"></el-table-column>
                <el-table-column show-overflow-tooltip prop="total" label="总件数"></el-table-column>
                <el-table-column show-overflow-tooltip prop="packing" label="包装"></el-table-column>
                <el-table-column show-overflow-tooltip label="保价金额">
                  <template slot-scope="scope">¥{{scope.row.insuredLogisticsCost|priceFilter}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="transportType" label="运输方式"></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="expensePayer"
                  label="物流费用付款方"
                  width="120"
                ></el-table-column>
                <el-table-column show-overflow-tooltip prop label="*物流费用" width="84">
                  <template slot-scope="scope">{{scope.row.logisticsCost|priceFilter}}</template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页器 -->
            <div class="lpagination" style="margin-top:15px;float:right;">
              <el-pagination
                align="center"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[30]"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="uploadTable.length"
              ></el-pagination>
            </div>
          </div>

          <div v-if="isAbnormal">
            <el-row style="border-bottom:1px solid #DCDDDE;padding:10px 0;">
              <el-col :span="2" style="text-align:right">
                <i class="el-icon-warning-outline" style="font-size: 33px;color:$btnDanger"></i>
              </el-col>
              <el-col :span="22" style="padding-left:20px;">
                <div>
                  异常数据:
                  <span style="color:#C11A1A">{{normalMap.abnormal}}条</span>
                </div>
                <div>
                  正常数据:
                  <span style="color:#61CA6E">{{normalMap.normal}}条</span>
                </div>
              </el-col>
            </el-row>
            <el-row style="padding-left:30px;">
              <el-col :span="24">
                <h5>异常提醒:</h5>
              </el-col>
              <el-col :span="24" v-for="(item,index) in abnormalListVo" :key="index">{{item}}</el-col>
            </el-row>
          </div>
        </div>
        <div class="import-data" v-show="activeIndex===3">
          <div style="text-align:center;margin-top:50px;">
            <i class="el-icon-success"></i>
            <h4>批量导入完成</h4>
            <div style="color:#83878A;">
              您已成功导入
              <span>{{count}}</span>条数据
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" style="padding-top:10px;">
      <el-button type="primary" @click="onNext" v-if="activeIndex!=stepsList.length">下一步</el-button>
      <el-button type="primary" @click="onLast" v-if="activeIndex===2" plain>重新上传</el-button>
      <el-button v-else @click="dialogVisibleLeadIn = false">取 消</el-button>
    </div>
    <loading></loading>
  </el-dialog>
</template>
<script>
import loading from '@/components/Loading'
import { stepsList } from './utils/data'
import { uploadDownExcel } from '@/util/tool'
import { querySystemAttachmentAddressVo } from '@/api/purchase/purchaseManage'
import { getToken } from '@/util/auth' // get token from cookie
import { addEnquiryAffirm } from '@/api/sell/sellManage'
import { addImportLogistic } from '@/api/fiance/fianceManage'

export default {
  name: 'leadIn',
  components: { loading },
  data() {
    return {
      fileListUp: [],
      isMax: false, // 删除图片时 恢复显示
      count: 0,
      guid: '',
      name: '',
      currentPage: 1,
      pageSize: 30,
      isAbnormal: false,
      dialogVisibleLeadIn: false,
      stepsList: [],
      uploadTable: [],
      activeIndex: 1,
      uploadHeaders: {},
      fileList: [],
      normalMap: {},
      actionUrl: '',
      quoteTable: [] // 异常数据
    }
  },
  created() {
    this.uploadHeaders = {
      Authorization: ` Bearer ${getToken()}`
    }
    this.stepsList = stepsList
  },

  methods: {
    beforeUpload(file) {
      // 显示loading
      this.bus.$emit('loading', true)
      // 判断图片的类型
    },
    deleteExcel() {
      this.fileListUp = []
      this.fileList = []
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.fileList = [] // 上传成功进行隐藏
        if (response.obj.abnormalListVo.abnormalList.length !== 0) {
          // 导入数据有异常
          this.abnormalListVo = response.obj.abnormalListVo.abnormalList
          this.normalMap = response.obj.abnormalListVo.normalMap
          this.isAbnormal = true
        } else {
          // 导入数据无异常
          this.uploadTable = response.obj.excelList
          this.isAbnormal = false
        }
        this.importDataParams = response.obj
        this.fileListUp = fileList // 用来判断是否上传excel
      } else {
        this.$message.error(response.msg)
        this.fileList = []
      }
      // 关闭loading
      this.bus.$emit('loading', false)
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    downLoadFile() {
      querySystemAttachmentAddressVo(this.guid).then((res) => {
        if (res.data.code === 200) {
          uploadDownExcel(this.$store.state.https + res.data.obj.filePath, this.name)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onLeadIn(guidExcel, nameExcel) {
      this.guid = guidExcel
      this.name = nameExcel
      this.activeIndex = 1
      this.fileListUp = []
      this.fileList = []
      if (this.guid === this.$store.state.sellGuidIn) {
        this.actionUrl = '/api/orderContractBase/enquiryPreview' // 销售-询价导入数据预览
      } else if (this.guid === this.$store.state.financeLogisticCoeDerive) {
        this.actionUrl = '/api/financeLogistic/queryFinanceLogisticPreview' // 财务物流&快递费用导入-预览
      }
      this.dialogVisibleLeadIn = true
    },
    // 下一步
    onNext() {
      if (this.activeIndex === 1) {
        if (this.fileListUp.length === 0) {
          this.$message.error('未上传数据文件')
        } else {
          this.activeIndex += 1
          this.$refs.upload.submit()
        }
      } else if (this.activeIndex === 2) {
        // 导入数据操作
        this.bus.$emit('loading', true)
        if (this.guid === this.$store.state.sellGuidIn) {
          // 导入数据
          addEnquiryAffirm(this.importDataParams).then((res) => {
            if (res.data.code === 200) {
              this.activeIndex += 1
              this.count = res.data.obj.successCount
              setTimeout(() => {
                this.$emit('onRefresh', res.data.obj.productBaseSelectsVoList)
                this.dialogVisibleLeadIn = false
              }, 3000)
            } else {
              this.$message.error(res.data.msg)
            }
            this.bus.$emit('loading', false)
          })
        } else if (this.guid === this.$store.state.financeLogisticCoeDerive) {
          addImportLogistic(this.importDataParams).then((res) => {
            if (res.data.code === 200) {
              this.activeIndex += 1
              this.count = res.data.obj
              setTimeout(() => {
                this.$emit('onRefresh')
                this.dialogVisibleLeadIn = false
              }, 3000)
            } else {
              this.$message.error(res.data.msg)
            }
            this.bus.$emit('loading', false)
          })
        }
      }
    },
    // 重新上传
    onLast() {
      this.activeIndex -= 1
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    }
  }
}
</script>
<style lang="scss" scoped>
.p-content {
  color: #83878a;
  font-size: 12px;
  margin: 5px 0 7px !important;
}
.title-content {
  padding-left: 1px;
}
.lpagination {
  display: flex;
  justify-content: flex-end;
  // text-algin:right;
  width: 100%;
  padding: 0px 0px 20px;
}
.table-content {
  height: 405px;
}
.main {
  height: 480px;
  .header {
    display: flex;
    justify-content: space-between;
    width: 70%;
    margin: auto;
    .header-data-upLoad {
      width: 45%;
    }
    .header-data-preview {
      width: 45%;
    }
    .header-import-data {
      width: 20%;
    }
    .header-item {
      display: flex;
      text-align: center;
      .header-item-line {
        background-color: #ced1d7;
        width: 120px;
        height: 1px;
        margin-top: 15px;
        margin-left: 13px;
        text-align: center;
      }
      .pitch-on {
        height: 30px;
        width: 30px;
        line-height: 30px;
        background: #276cff !important;
        color: #fff;
        border-radius: 30px;
      }
      .header-item-lineAfter {
        background-color: #276cff;
        width: 120px;
        height: 1px;
        margin-top: 15px;
        margin-left: 13px;
        text-align: center;
      }
      .header-item-number {
        height: 30px;
        width: 30px;
        line-height: 30px;
        border: 1px solid #cdd1d7;
        color: #cdd1d7;
        border-radius: 30px;
      }
      .header-item-title {
        line-height: 30px;
        padding-left: 10px;
        font-size: 15px;
      }
    }
  }
  .bottom-content {
    padding-top: 70px;
  }
  .top-content {
    padding-top: 20px;
  }
  .content {
    h4 {
      font-size: 14px;
    }
    .specail-suggestion {
      p {
        color: #83878a;
        font-size: 12px;
        margin: 5px 0 1px !important;
      }
    }

    .upload-files {
      .el-row {
        margin-top: 30px;
      }
      .el-icon-folder-add,
      .el-icon-folder-checked,
      .el-icon-warning-outline {
        font-size: 33px;
      }
      h4 {
        margin: 0px !important;
      }
    }
    .data-preview,
    .import-data {
      margin-top: 30px;
      .el-icon-success {
        font-size: 60px;
        color: #61ca6e;
      }
    }
  }
}
.footer {
  margin-top: 30px;
  text-align: right;
}
</style>
